import * as path from 'path';
import * as fs from 'fs';
export function tryReadFile(filePath: string | string[]) {
  const filePaths : string[] = Array.isArray(filePath) ? filePath : [filePath];
  for(let j = 0; j < filePaths.length; j++) {
    const paths = [filePaths[j], path.join(process.cwd(), filePaths[j])];
    for(let i = 0 ; i < paths.length; i++) {
      try {
        if(fs.existsSync(paths[i])) {
          return fs.readFileSync(paths[i], 'utf8');
        } 
      } catch(err) {};
    }
  }
 
  return null;
}

export function tryReadJson(filePath: string | string[]) {
  try {
    const f = tryReadFile(filePath);
    if(f) {
      return JSON.parse(f); 
    }
  } catch {};
  return null;
}

export function getApiKey(object: { apiKey?: string, apiKeyPath?: string }) {
  if(object.apiKeyPath) {
    return tryReadFile(object.apiKeyPath)
  } else {
    return object.apiKey;
  }
}